import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Tooltip from 'modules/core/components/Tooltip'
import i18n from 'modules/core/lib/i18n'

interface Props {
  hasMissingField: boolean
}

const AlertTooltip = ({ hasMissingField }: Props) => {
  const iconColor = hasMissingField ? 'radicalRed1000' : 'grey800'

  const label = hasMissingField
    ? i18n.t('custom_reports.missing_field')
    : i18n.t('custom_reports.invalid_data_source')

  return (
    <Tooltip.Alt attachment="bottom center" label={label}>
      <Icon.Medium icon="alert-circle" color={iconColor} />
    </Tooltip.Alt>
  )
}

export default observer(AlertTooltip)
